export const WORKFLOW_STEP_0 = 0
export const WORKFLOW_STEP_1 = 1
export const WORKFLOW_STEP_2 = 2
export const WORKFLOW_STEP_FINISHED = 3
